"use strict";
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});
var form = document.querySelector(".form");
form.addEventListener("submit", function(event) {
    event.preventDefault();
    form.reset();
});

//# sourceMappingURL=index.08084537.js.map
